import { z as baseZ, type ZodError, type ZodString, type ZodType } from "zod"

import { extendZod } from "./extension"


export * from "./e164Phone"
export * from "./localizedString"

export type RpcbaseZod = typeof baseZ & {
  e164Phone: (options?: import("./e164Phone").E164PhoneOptions) => ZodString
}

export const z = Object.create(baseZ) as RpcbaseZod
extendZod(z)

export namespace z {
  export type infer<T> = import("zod").infer<T>
  export type input<T> = import("zod").input<T>
  export type output<T> = import("zod").output<T>
  export type TypeOf<T> = import("zod").TypeOf<T>
  export type Infer<T> = import("zod").Infer<T>
}

export { extendZod, ZodError, ZodType }
